<!--
 * @Author: Latte
 * @Date: 2021-10-21 08:46:35
 * @LAstEditors: Latte
 * @LastEditTime: 2022-02-25 14:08:44
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\module-management\module-customization\index.vue
-->
<template>
  <div class="app-container">
    <div class="topbar">
      <el-button size="small" @click.stop="$router.go(-1)">返 回</el-button>
      <div>
        <el-button type="primary" size="small" @click.stop="handleOpenAddModuleDlg">添加栏目</el-button>
      </div>
    </div>
    <el-card type="border-card">
      <el-table :data="tableData" :header-cell-style="{ background: '#F5F7FA' }"
                style="width: 100%; margin-bottom: 20px"
                border>
        <el-table-column label="排序" prop="sort" align="center" sortable></el-table-column>
        <el-table-column label="ID" prop="maiColumnID" align="center"></el-table-column>
        <el-table-column label="模块封面" prop="maiColumnID" align="center">
          <template #default="scope">
            <el-image
                style="height: 40px"
                fit="scale-down"
                :src="getImageUrl(scope.row.coverUrl)"
                :preview-src-list="[getImageUrl(scope.row.coverUrl)]"
            >
              <template #error>
                <div>
                </div>
              </template>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="子模块名称" prop="columnName" align="center"></el-table-column>
        <el-table-column label="子模块名称(俄语)" prop="columnNameRussian" align="center"></el-table-column>
        <el-table-column label="描述" prop="columnDesc" align="center"></el-table-column>
        <el-table-column label="状态" prop="isEnable" align="center" width="200">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isEnable" active-text="启用" inactive-text="禁用"
                       @change="handleChangeStatus($event, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="筛选条件配置" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click.stop="
                $router.push({
                  name: 'filterSetting',
                  params: {
                    row: scope.row,
                  },
                })
              ">筛选设置
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click.stop="handleOpenEditModuleDLg(scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click.stop="handleRemove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="editType === 'create' ? '新增模块' : '编辑模块'" :visible.sync="dialogVisible" width="60%"
               :close-on-click-modal="false">
      <el-form ref="editFormRef" :model="editForm" :inline="true" label-position="top" v-loading="uploadLoading">
        <el-form-item label="栏目码" prop="columnCode"
                      :rules="[{ required: true, message: '必填项', trigger: 'blur' }]" style="width: 30%">
          <el-input v-model="editForm.columnCode" :disabled="editType === 'edit'"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="columnName"
                      :rules="[{ required: true, message: '必填项', trigger: 'blur' }]" style="width: 30%">
          <el-input v-model="editForm.columnName"></el-input>
        </el-form-item>
        <el-form-item label="名称(俄语)" prop="columnNameRussian" style="width: 30%">
          <el-input v-model="editForm.columnNameRussian"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="isEnable"
                      :rules="[{ required: true, message: '必填项', trigger: 'blur' }]" style="width: 30%">
          <el-switch v-model="editForm.isEnable"></el-switch>
        </el-form-item>
        <!--        <el-form-item label="级别" prop="level" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">-->
        <!--          <el-select v-model="editForm.level" :disabled="editType === 'edit'">-->
        <!--            <el-option :value="-1" label="根"></el-option>-->
        <!--            <el-option :value="0" label="一级"></el-option>-->
        <!--            <el-option :value="1" label="二级"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="资源类型" prop="resourceType"-->
        <!--                      :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">-->
        <!--          <el-select v-model="editForm.resourceType" :disabled="editType === 'edit'">-->
        <!--            <el-option :value="0" label="live"></el-option>-->
        <!--            <el-option :value="1" label="video"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-form-item label="排序" prop="sort" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
                      style="width: 30%">
          <el-input-number v-model="editForm.sort"></el-input-number>
        </el-form-item>

        <el-form-item v-if="userDataTypeOption.length > 0" label="所属领域" prop="userDataType"
                      :rules="[{ required: true, message: '必填项', trigger: 'blur' }]" style="width: 30%">
          <el-select v-model="editForm.userDataType" :disabled="editType === 'edit'">
            <el-option v-for="item in userDataTypeOption" :key="item.value" :value="item.value"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="columnDesc" style="width: 40%">
          <el-input type="textarea" style="width: 300px" v-model="editForm.columnDesc"></el-input>
        </el-form-item>
        <el-form-item label="模块封面" prop="cover" style="width: 40%">
          <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                     :on-change="change2DisplayLocalImage" :auto-upload="false">
            <div style="text-align: left;">
              <el-image style="width: 100px; height: 100px"
                        :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(editForm.coverUrl)"
                        fit="scale-down">
                <template #error>
                  <p></p>
                </template>
              </el-image>
              <br/>
              <el-button size="small" type="primary">点击上传</el-button>
            </div>

            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="submiEditForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addColumn,
  getColumnList,
  updateColumn,
  deleteColumn,
} from "@/api/system/columnManagement/index";
import {getUserType} from "@/utils/userutil";
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import {deepClone} from "@/utils";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {isVaild} from "@/utils/validate";
import {uploadFile2OSS} from "@/utils/OSSUpload";
import {handleRes} from "@/utils/handleRes";

export default {
  props: {
    parentID: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      editForm: {},
      editType: "", //新增还是编辑
      userDataTypeOption: [],
      uploadCoverFile: null,
      uploadCoverFileURL: "",
      uploadLoading: false
    };
  },
  created() {
    this.userDataTypeOption = getUserType()
    this.getColumnList();
  },
  methods: {
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    /**
     * 获取栏目
     */
    async getColumnList() {
      const params = {
        belongToIndex: this.parentID,
      };

      const res = await getColumnList(params);
      this.tableData = res.data;
      //console.log("tableData", this.tableData);
    },
    // 控制栏目状态
    async handleChangeStatus(status, row) {
      const params = {
        maiColumnID: row.maiColumnID,
        isEnable: status,
        columnName: row.columnName,
      };

      const res = await updateColumn(params);
      if (res.code === 200) {
        this.$message.success("操作成功");
      } else {
        this.$message.error("操作失败");
      }
    },
    /**
     * 弹出新增栏目对话框
     */
    handleOpenAddModuleDlg() {
      this.editForm = {
        isEnable: true
      }
      this.editType = 'create'
      this.dialogVisible = true
      this.$refs.editFormRef.clearValidate()
    },
    /**
     * 弹出编辑栏目对话框
     * @param {Object} row
     */
    handleOpenEditModuleDLg(row) {
      this.editForm = deepClone(row)
      this.editType = 'edit'
      this.dialogVisible = true;
      this.$refs.editFormRef.clearValidate()
    },
    /**
     * 删除模块
     */
    async handleRemove(row) {
      this.$confirm("此操作将永久删除该模块, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteColumn({
          id: row.maiColumnID
        }).then(res => {
          handleRes(res, () => {
            this.getColumnList()
          })
        })
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },
    submiEditForm() {
      this.$refs.editFormRef.validate(async (res) => {
        if (res) {
          const para = deepClone(this.editForm)
          if (this.editType === 'create') {
            para.parentID = this.parentID
            para.level = 1
          }

          this.uploadLoading = true;
          let savepathParamsRes = await getOSSUploadInfo({
            DataType: "33",
            ID: "0",
          });
          if (!isVaild(savepathParamsRes)) {
            this.uploadLoading = false;
            return;
          }
          let savePathParams = savepathParamsRes.resultData

          //上传封面
          if (isVaild(this.uploadCoverFile)) {
            // printObj(this.uploadCoverFile.raw)
            let timestamp = new Date().valueOf();

            let uploadRes;
            let fileName;
            if (isVaild(this.uploadCoverFile)) {
              fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
              // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
              uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
                type: this.uploadCoverFile.raw.type
              }), fileName)
            }
            if (uploadRes.status === 0) {
              para.coverUrl = "/" + fileName
              // console.log(this.form.liveCover)
            } else {
              this.$message({
                type: "error",
                message: "上传失败"
              })
            }
            this.$refs.uploadCoverRef.clearFiles();
          }

          if (this.editType === 'create') { ///新增模块
            addColumn(para).then(res => {
              handleRes(res, () => {
                this.getColumnList()
                this.dialogVisible = false
              })
              this.uploadLoading = false;
            })
          } else if (this.editType === 'edit') { ///编辑模块
            updateColumn(para).then(res => {
              handleRes(res, () => {
                this.getColumnList()
                this.dialogVisible = false;
              })
              this.uploadLoading = false;
            })
          }
        }
      })
    },
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    }
  },
};
</script>

<style>
</style>
